import WebFont from 'webfontloader';
import { validate as isUUID } from 'uuid';

const FONT_PREFIX = 'plural_font';

function getFamilyFrom(source) {
  const paths = source.split('/');
  const fileName = paths[paths.length - 1];
  const [fontFamily] = fileName.split('.');
  return fontFamily;
}

function loadFont(source) {
  const family = getFamilyFrom(source);

  const fontFamily = `${FONT_PREFIX}_${family}`;
  // Create new style with font family and class styles if not exist
  if (!document.getElementById(fontFamily)) {
    const newStyle = document.createElement('style');
    newStyle.setAttribute('style', 'text/css');
    newStyle.setAttribute('id', fontFamily);

    newStyle.appendChild(document.createTextNode(`\
      @font-face {
        font-family: ${fontFamily};
        src: url(${source});
      }`));
    document.head.appendChild(newStyle);
  }

  return { fontFamily };
}

function addPrefixIfRequired(fontFamily) {
  return isUUID(fontFamily) ? `${FONT_PREFIX}_${fontFamily}` : fontFamily;
}

function buildFontFamily(fontFamily) {
  return fontFamily ? `${addPrefixIfRequired(fontFamily)}, Roboto` : 'Roboto';
}

function loadGoogleFonts(googleFonts) {
  if (googleFonts.length) {
    WebFont.load({
      google: {
        families: googleFonts,
      },
    });
  }
}

export default {
  loadFont,
  buildFontFamily,
  loadGoogleFonts,
};
